export const useIsTouchDevice = () =>
  window.matchMedia('(pointer: coarse)').matches;
